import React from 'react';
const Navbar = () => {
  return (
    <div className="navbar" id="navbar">
      <div className="container">
        <span className="brand-logo">
          <img src="images/logo.png" alt="Logo" />
        </span>
        <ul>
          <li><a href="#aboutMe">About Me</a></li>
          <li><a href="#portfolio">Portfolio</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </div>
    </div>
  );
}

export default Navbar;